import type { GlobalStore } from "../store";

const bridge = (s: GlobalStore) => s.bridge;
const appId = (s: GlobalStore) => bridge(s).appId;
const debug = (s: GlobalStore) => bridge(s).debug;
const mode = (s: GlobalStore) => bridge(s).mode;
const organizationId = (s: GlobalStore) => bridge(s).organizationId;
const source = (s: GlobalStore) => bridge(s).source;
const workspaceId = (s: GlobalStore) => bridge(s).workspaceId;
const isIframeMode = (s: GlobalStore) => mode(s) === "iframe";

export const bridgeSelectors = {
  appId,
  bridge,
  debug,
  isIframeMode,
  mode,
  organizationId,
  source,
  workspaceId,
};
